import { render, staticRenderFns } from "./submitData.vue?vue&type=template&id=05b76033&"
import script from "./submitData.vue?vue&type=script&lang=js&"
export * from "./submitData.vue?vue&type=script&lang=js&"
import style0 from "./submitData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports